import React from 'react';

import Tooltip from 'react-native-walkthrough-tooltip';

const TooltipWrapper = ({
  isVisible,
  onClose,
  placement,
  content,
  theme,
  tooltipStyle,
  children,
}) => {
  return (
    <Tooltip
      animated={true}
      //(Optional) When true, tooltip will animate in/out when showing/hiding
      arrowSize={{ width: 16, height: 8 }}
      //(Optional) Dimensions of arrow bubble pointing to the highlighted element
      backgroundColor="rgba(0,0,0,0.6)"
      //(Optional) Color of the fullscreen background beneath the tooltip.
      isVisible={isVisible}
      //(Must) When true, tooltip is displayed
      content={content}
      //(Must) This is the view displayed in the tooltip
      placement={placement || 'bottom'}
      //(Must) top, bottom, left, right, auto.
      onClose={onClose}
      //(Optional) Callback fired when the user taps the tooltip
      tooltipStyle={tooltipStyle}
      disableShadow={true}
      arrowStyle={{ borderTopColor: theme.colors.primary }}
      contentStyle={{
        backgroundColor: theme.colors.onBackground,
        borderWidth: 1,
        borderColor: theme.colors.primary,
        width: 'auto',
      }}
    >
      {children}
    </Tooltip>
  );
};
export default TooltipWrapper;
